/**
 * i18n routing config (Вариант B — локализуется ТОЛЬКО публичная часть).
 *
 * Чистый модуль без React/тяжёлых зависимостей: импортируется в middleware
 * (edge runtime). Не импортировать сюда messages/*.json.
 */

export const LOCALES = ["en", "ru"] as const;
export type AppLocale = (typeof LOCALES)[number];

/** По решению пользователя: авто-EN для не-RU посетителей. */
export const DEFAULT_LOCALE: AppLocale = "en";

export const LOCALE_COOKIE = "keiront.locale";

/**
 * Префиксы публичных путей, участвующих в `/en` `/ru`-роутинге (помимо главной `/`).
 * Всё остальное (кабинет, auth, admin, api) — без локали.
 */
export const PUBLIC_PREFIXES = [
  "/pricing",
  "/about",
  "/contact",
  "/blog",
  "/compare",
  "/product",
  "/legal",
  "/knowledge",
] as const;

export function isLocale(v: string | undefined | null): v is AppLocale {
  return v === "en" || v === "ru";
}

/** Путь относится к публичной (локализуемой) части? */
export function isPublicPath(pathname: string): boolean {
  if (pathname === "/") return true;
  return PUBLIC_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(p + "/"),
  );
}

/** Отделить ведущий `/en` или `/ru`. rest всегда начинается с `/`. */
export function splitLocale(pathname: string): {
  locale: AppLocale | null;
  rest: string;
} {
  const m = pathname.match(/^\/(en|ru)(\/.*)?$/);
  if (m) return { locale: m[1] as AppLocale, rest: m[2] || "/" };
  return { locale: null, rest: pathname };
}

/** Грубый парс Accept-Language: ru* → ru, иначе → en. */
export function localeFromAcceptLanguage(header: string | null): AppLocale {
  if (!header) return DEFAULT_LOCALE;
  const first = header.split(",")[0]?.trim().toLowerCase() ?? "";
  return first.startsWith("ru") ? "ru" : "en";
}

/** Построить локализованный путь: ('/pricing','en') → '/en/pricing'; ('/','ru') → '/ru'. */
export function withLocale(pathname: string, locale: AppLocale): string {
  return `/${locale}${pathname === "/" ? "" : pathname}`;
}
